import { z } from 'zod';
export const inboundEnrollConfigSchema = z.object({
    enabled: z.boolean().default(false),
    campaign_name: z.string().min(1).max(200),
});
export function parseInboundEnrollConfig(raw) {
    if (!raw || typeof raw !== 'object')
        return null;
    const parsed = inboundEnrollConfigSchema.safeParse(raw);
    return parsed.success ? parsed.data : null;
}
/** FO B-08 default campaign names per project slug. */
export const DEFAULT_INBOUND_ENROLL_BY_SLUG = {
    ploko: { enabled: true, campaign_name: 'Ploko | nurture | inbound-30d' },
    pirova: { enabled: true, campaign_name: 'Pirova | nurture | inbound-30d' },
};
//# sourceMappingURL=inboundEnroll.js.map